import React from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { useIntl, defineMessages } from "react-intl";
import { InfoOutlineIcon } from "../../../common/icons";

const messages = defineMessages({
  description: {
    id: "vehicle.single.registry.infoAlertCardSolutions.description",
    defaultMessage:
      "You will be able to select the codes in the upload spreadsheet within the toll tab.",
  },
});

const useStyles = makeStyles(() => ({
  container: {
    minHeight: "62px",
    width: "100%",
    padding: "5px",
    boxSizing: "border-box",
    backgroundColor: "#E7F3FF",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  icon: {
    flex: "0 0 24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  description: {
    flex: 1,
    minWidth: 0,
    margin: 0,
    fontSize: "12px",
    color: "#1E293B",
    lineHeight: "18px",
    textAlign: "left",
  },
}));

export const InfoAlertCardSolutions = ({}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Box className={classes.container}>
      <div className={classes.icon}>
        <InfoOutlineIcon />
      </div>
      <p className={classes.description}>
        {intl.formatMessage(messages.description)}
      </p>
    </Box>
  );
};
